import { connect } from 'react-redux';
import { AppState } from '../../state/state';
import Loader from './loader';
export default connect((state: AppState, props: { targets: string[] }) => ({
  show: props.targets.some(reactToTarget => state.loading.targets.some(t => t.key === reactToTarget))
}))(Loader);
